import { Component, Prop, h } from '@stencil/core';

import { actions as bannerAction } from '../../../actions/actions.interactive-banner';
import { bannerSizeType } from '../../../utils/utils.interactive-banner';

@Component({
  tag: 'banner-continue',
  styleUrl: 'banner-continue.css',
})
export class BannerContinue {
  @Prop() yearId: number;
  @Prop() make: string;
  @Prop() model: string;
  @Prop() trim: string;
  @Prop() showDesktop: boolean = false;
  @Prop() continueSize: bannerSizeType = 'large';

  continue() {
    bannerAction.continueSessionStorage();
  }

  render() {
    const textLink = 'Start a New Offer';
    const bannerContinueBlockClass = {
      'banner-continue-block': true,
      'flex-col py-4': !this.showDesktop,
      'py-3': this.showDesktop,
    };

    const containTitleAlmostDoneClass = {
      'mb-4': this.continueSize !== 'large',
      'mt-4': this.continueSize === 'small' || this.continueSize === 'xsmall',
      'text-center': this.continueSize === 'large',
    };

    const titleAlmostDoneClass = {
      'banner-continue-title': true,
      'text-left': this.continueSize !== 'large',
    };

    const bannerContainResetClass = {
      'flex items-end': this.continueSize === 'medium',
    };

    const bannerResetClass = {
      'basis-13p flex flex-col items-center': this.continueSize === 'small' || this.continueSize === 'xsmall',
      'basis-13p flex flex-col items-reverse': this.continueSize !== 'small' && this.continueSize !== 'xsmall',
    };

    const bannerKBBLogoWithLinkClass = {
      'grow-1': this.showDesktop,
      'basis-full': !this.showDesktop,
      'pt-0': true,
    };

    const bannerLogoClass = {
      'flex items-center -mt-3': this.continueSize === 'large',
      absolute: this.continueSize === 'medium',
    };

    const subContent = {
      'text-xs/4 text-left': true,
    };

    const logoContainClass = {
      'flex flex-row flex-row-reverse justify-between': this.continueSize === 'medium',
      'flex flex-row justify-between': this.continueSize === 'large',
    };

    const continueAndResetClass = {
      'flex flex-col-reverse justify-between': this.continueSize === 'large',
      'flex flex-row justify-between': this.continueSize === 'medium',
      'flex flex-col': this.continueSize === 'small',
    };

    const carNameClass = {
      'w-1/2': this.continueSize === 'medium',
    };

    const carName = `${this.yearId} ${this.make} ${this.model} ${this.trim}`;
    return (
      <div class={bannerContinueBlockClass}>
        <div class={logoContainClass}>
          <div class={bannerLogoClass}>
            <banner-logo
              textLink={textLink}
              hiddenOnMobile={false}
              txtLinkHiddenOnDesktop={true}
              showDesktop={this.showDesktop}
              class={bannerKBBLogoWithLinkClass}
              hiddenReset={true}
              logoWithMPTop={false}
            />
          </div>
        </div>
        <div class={containTitleAlmostDoneClass}>
          <div class="mb-2">
            <h1 class={titleAlmostDoneClass}>You're Almost Done</h1>
            <span class={subContent}>No need to start over, we saved your progress...</span>
          </div>

          <div class={carNameClass}>
            <span class={subContent}>Your vehicle:</span>
            <p class="mt-0 mb-0 font-semibold font-open-sans">{carName}</p>
          </div>
        </div>
        <div class={continueAndResetClass}>
          <div>
            <ico-button
              label="Continue"
              buttonSize="xmedium"
              whenClicked={() => {
                this.continue();
              }}
            />
          </div>
          <div class={bannerContainResetClass}>
            <banner-reset textLink={textLink} showDesktop={this.showDesktop} class={bannerResetClass} textResetSize="sm" />
          </div>
        </div>
      </div>
    );
  }
}
